import React, {useEffect, useState, useContext} from 'react';
import CheckField from '../../CheckField2/CheckField'
import {TextField} from '../../TextField/TextField'
import {ConfigContext} from '../../../screens/form/DynamicForm/DynamicForm'
import './styles.scss'

export const TexasHealthFacilities = ({formik, dbFormSpec}) => {
  
  const [checkedFacilities, setCheckedFacilities] = useState([])
  const [summaryModalOpened, setSummaryModalOpened] = useState(false)
  
  const context = useContext(ConfigContext)
  console.log(context)

  // if the list of checked orgs is empty, set the value of facilityOrPhysician to an empty string
  useEffect(()=>{
    if (checkedFacilities.length === 0 && formik.values.facilityOrPhysician) {
      formik.setFieldValue('facilityOrPhysician', '')
    }
    else if (checkedFacilities.length > 0 && formik.values.facilityList.length > 0 && formik.values.facilityList[0].length > 0 && formik.values.facilityOrPhysician === '') {
      formik.setFieldValue('facilityOrPhysician', 'on')
    }
  })
  
  useEffect(()=>{
    typeof formik.values.facilityList === 'string' && formik.setFieldValue('facilityList', [formik.values.facilityList])  
    formik.values.facilityList.length > 0 && formik.values.facilityList[0].length > 0 ? formik.setFieldValue('facilityOrPhysician', 'on') : formik.setFieldValue('facilityOrPhysician', '')
  }, [formik.values.facilityList])

  useEffect(()=>{
    if (context.showSummary) {
      setSummaryModalOpened(true);
      let checkedFacilitiesToAdd = checkedFacilities.filter((value)=>{
        if (!formik.values.facilityList.includes(value)) {
          return value
        }
      })
      formik.setFieldValue('facilityList', [...checkedFacilitiesToAdd, ...formik.values.facilityList])
    }
    else if (!context.showSummary && summaryModalOpened) {
      console.log('summary-modal not found')
      formik.setFieldValue('facilityList', formik.values.facilityList.filter((value, index)=>{
            return value !== 'Texas Health' && value !== 'THPG Clinics' && value !== 'Texas Health Urgent Care'
      }))
      console.log(formik.values.facilityList)
    }
  }, [context.showSummary])


  return (
    <div className="texas-health-facilities">
      <div className="facilitiesList">
        {dbFormSpec.release.facilities.map((item, index) => {
          return (
            (!item.type) && (item.key !== 'otherFac') &&
            <div className='facility-item' key={index}>
              <CheckField checkboxType={'selectAndTypeFacility'} formik={formik} formValue={item.key} checkItemLabel={item.value} trueFormSpec={dbFormSpec} localFacilities={{set: setCheckedFacilities, value: checkedFacilities}}/>
            </div>
          )
        })}

      </div>
      
      
      {/* <label className={`check-field2 subtitle2`} style={{background: '#c2c2c2', marginBottom: 20}}> <Icon_Check /> {'Texas Health'} </label> */}
      <br />
      <TextField formik={formik} fieldId={'facilityList'} cssField={'fname-field'} label={'Hospital, Clinic, or Provider Name'} maxLength={100} variant={'select+type'}/>
      
    </div>
  )
}